import { TFunction } from "i18next";
import { z } from "zod";

import { Roles } from "src/core/constants/roles";
import {
  contactInformationSchema,
  defaultContactInformationValues,
} from "src/core/forms/create-client/contactInformations.schema";
import {
  createClientCommonSchema,
  defaultCreateClientCommonValues,
} from "src/core/forms/create-client/createClientCommon.schema";
import { FR_SIREN_REGEX } from "src/core/forms/validators/regex";
import { User } from "src/core/gql/graphql";

export const createClientSirenSchema = (t: TFunction, showContactInfo = false) =>
  contactInformationSchema(t, showContactInfo)
    .merge(createClientCommonSchema)
    .extend({
      siren: z
        .string({ required_error: t("global.form.error.mandatoryField") })
        .min(1, { message: t("global.form.error.mandatoryField") }),
    })
    .superRefine((data, ctx) => {
      if (!FR_SIREN_REGEX.test(data.siren)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: t("form.entreprise.error.sirenInvalid"),
          path: ["siren"],
        });
      }
    });

export type CreateClientSirenFormValues = z.infer<ReturnType<typeof createClientSirenSchema>>;

export const defaultCreateClientSirenValues = (
  user: User,
  hasRole: (role: Roles) => boolean
): CreateClientSirenFormValues => {
  return {
    ...defaultContactInformationValues(),
    ...defaultCreateClientCommonValues(user, hasRole),
    siren: "",
  };
};
